import {
  useCuentaContableEmpresaCliente,
  useCuentaContableEmpresaCompra,
  useCuentaContableEmpresaProveedor,
  useCuentaContableEmpresaVenta,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaCliente,
  useCuentaContableCuentaCompra,
  useCuentaContableCuentaProveedor,
  useCuentaContableCuentaVenta,
} from "api/CuentaContable_Cuenta.hook"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import PanelsHeader from "features/Contactos/components/PanelsHeader"
import { contactFormTaxesMapper } from "features/Contactos/constants"
import useContactos from "features/Contactos/hooks/useContactos"
import mapContactoContabilidadToApi from "features/Contactos/mappers/mapContactoContabilidadToApi"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { withFormik } from "formik"
import { DropdownChangeParams } from "primereact/dropdown"
import { useTranslation } from "react-i18next"
import TaxesCustomer from "../../components/TaxesCostumer"

const FormContabilidad = ({
  setFieldValue,
  values,
  handleSubmit,
  isValid,
  dirty,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { contacto } = useContactos()
  const { getCuentaContablePorDefecto } = useCuentasContables()

  const {
    cuentasContablesEmpresas: listaDeCuentasClientes,
    cuentasContablesEmpresasRefetch: refreshCuentaClientes,
  } = useCuentaContableEmpresaCliente()
  const { cuentasContablesEmpresas: listaDeCuentasClientesBase } =
    useCuentaContableCuentaCliente()
  const initialPorDefectoClientes = listaDeCuentasClientesBase?.find(
    (element) =>
      element?.cuentaContableEmpresaBase?.id ===
      getCuentaContablePorDefecto(CATEGORIA_CUENTA_CONTABLE_ENUM.CLIENTE)
  )

  const {
    cuentasContablesEmpresas: listaDeCuentasProveedores,
    cuentasContablesEmpresasRefetch: refreshCuentaProveedores,
  } = useCuentaContableEmpresaProveedor()
  const { cuentasContablesEmpresas: listaDeCuentasProveedoresBase } =
    useCuentaContableCuentaProveedor()
  const initialPorDefectoProveedores = listaDeCuentasProveedoresBase?.find(
    (element) =>
      element?.cuentaContableEmpresaBase?.id ===
      getCuentaContablePorDefecto(CATEGORIA_CUENTA_CONTABLE_ENUM.PROVEEDOR)
  )

  const {
    cuentasContablesEmpresas: listaDeCuentasVentas,
    cuentasContablesEmpresasRefetch: refreshCuentaVentas,
  } = useCuentaContableEmpresaVenta()
  const { cuentasContablesEmpresas: listaDeCuentasBaseVentas } =
    useCuentaContableCuentaVenta()

  const {
    cuentasContablesEmpresas: listaDeCuentasCompras,
    cuentasContablesEmpresasRefetch: refreshCuentaCompras,
  } = useCuentaContableEmpresaCompra()
  const { cuentasContablesEmpresas: listaDeCuentasComprasBase } =
    useCuentaContableCuentaCompra()

  const entities = [
    `${t("contactos.editar.dataAdvance.labelClient")}`,
    `${t("contactos.editar.dataAdvance.labelSupplier")}`,
  ]

  const isCliente = (entity: $TSMigrationFixMe) => entity === "Cliente"

  return (
    <>
      <PanelsHeader
        title={`${t("contactos.editar.dataAdvance.menuAccount")}`}
        handleSubmit={handleSubmit}
        disabled={!(isValid && dirty)}
      />

      <div className='p-fluid d-flex flex-column'>
        {entities.map((entity) => (
          <>
            <div className='mb-2 contactos-contabilidad__section d-flex'>
              {entity}
            </div>
            <div className='p-field d-flex-column'>
              <div className='flex-row d-flex'>
                <div className='mr-3 w-50'>
                  <label className='text-left w-100'>{`${t(
                    "contactos.editar.dataAdvance.labelAccount"
                  )} ${entity.toLowerCase()}`}</label>
                  <DropdownCuentasContablesConModal
                    cuentasContablesOptions={
                      isCliente(entity)
                        ? listaDeCuentasClientes
                        : listaDeCuentasProveedores
                    }
                    dropdownValue={values?.[`cuentaContable${entity}Id`]}
                    onChange={(event: DropdownChangeParams) =>
                      setFieldValue(`cuentaContable${entity}Id`, event.value)
                    }
                    listaDeCuentasBase={
                      isCliente(entity)
                        ? listaDeCuentasClientesBase
                        : listaDeCuentasProveedoresBase
                    }
                    refreshFetchData={
                      isCliente(entity)
                        ? refreshCuentaClientes
                        : refreshCuentaProveedores
                    }
                    withCreateCuenta
                    cuentaPorDefecto={
                      isCliente(entity)
                        ? initialPorDefectoClientes
                        : initialPorDefectoProveedores
                    }
                    nameOnCreate={contacto?.razonSocial}
                  />
                </div>
                <div className='w-50'>
                  <TaxesCustomer
                    isCliente={isCliente(entity)}
                    values={values}
                    setFields={setFieldValue}
                  />
                </div>
              </div>
              <div className='mt-1'>
                <label className='text-left w-100'>
                  {`${t("contactos.editar.dataAdvance.labelAccount")} ${
                    isCliente(entity)
                      ? `${t("contactos.editar.dataAdvance.labelSale")}`
                      : `${t("contactos.editar.dataAdvance.labelBuy")}`
                  }`}
                </label>
                <DropdownCuentasContablesConModal
                  cuentasContablesOptions={
                    isCliente(entity)
                      ? listaDeCuentasVentas
                      : listaDeCuentasCompras
                  }
                  dropdownValue={
                    values?.[
                      `cuentaContable${
                        isCliente(entity) ? "Venta" : "Compra"
                      }Id`
                    ]
                  }
                  onChange={(event: DropdownChangeParams) =>
                    setFieldValue(
                      `cuentaContable${
                        isCliente(entity) ? "Venta" : "Compra"
                      }Id`,
                      event.value
                    )
                  }
                  listaDeCuentasBase={
                    isCliente(entity)
                      ? listaDeCuentasBaseVentas
                      : listaDeCuentasComprasBase
                  }
                  refreshFetchData={
                    isCliente(entity)
                      ? refreshCuentaVentas
                      : refreshCuentaCompras
                  }
                  withCreateCuenta
                />
              </div>
            </div>
          </>
        ))}
      </div>
    </>
  )
}

const Form = withFormik({
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data, taxes }) => {
    return {
      cuentaContableClienteId: data?.cuentaContableClienteId,
      cuentaContableProveedorId: data?.cuentaContableProveedorId,
      cuentaContableVentaId: data?.cuentaContableVentaId,
      cuentaContableCompraId: data?.cuentaContableCompraId,
      impuestosCompra: data?.impuestosCompra,
      impuestosVenta: data?.impuestosVenta,
      empresaContactoId: data?.empresaContactoId,
      // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
      ...(data && contactFormTaxesMapper(data, taxes)),
    }
  },
  enableReinitialize: true,
  handleSubmit: async (values, { props }) => {
    const payload = mapContactoContabilidadToApi(values)
    // @ts-expect-error TS(2339): Property 'updateData' does not exist on type 'obje...
    props.updateData(payload)
  },
})(FormContabilidad)

export default Form
